module.exports = __webpack_public_path__ + "static/anna-5a78adb4a0e82270dfb9ed9813f54943.png";